export const AUTH_CACHE_ID_QUERY_PARAM = 'authCacheId'
